<span *ngIf="classe"> {{classe.nom}} </span>
